import React from 'react';
import {
  HiOutlinePhoneArrowUpRight,
  HiOutlinePhoneArrowDownLeft,
  HiOutlinePhoneXMark,
  HiOutlineUserGroup,
} from 'react-icons/hi2';
import { formatDate } from '../../common';
import { getCallTimelineLabel, isMissedCall } from '../../utils/callHistoryTimeline';
import { techColors } from '../../styles/TechRetroEffects';
import {
  CallTimelineRow,
  CallTimelineBubble,
  CallTimelineLabel,
  CallTimelineTime,
} from '../../styles/UserWorkspacePageStyles';

const CallDirectionIcon = ({ item }) => {
  if (item.kind === 'group') {
    return <HiOutlineUserGroup />;
  }
  if (item.state === 'missed' || (item.state === 'rejected' && item.direction === 'incoming')) {
    return <HiOutlinePhoneXMark />;
  }
  if (item.direction === 'outgoing') {
    return <HiOutlinePhoneArrowUpRight />;
  }
  return <HiOutlinePhoneArrowDownLeft />;
};

const CallTimelineItem = ({ item }) => {
  const missed = isMissedCall(item);
  const label = getCallTimelineLabel(item);
  const timeSource = item.ended_at || item.started_at;

  return (
    <CallTimelineRow>
      <CallTimelineBubble $missed={missed}>
        <CallDirectionIcon item={item} />
        <CallTimelineLabel>{label}</CallTimelineLabel>
        <CallTimelineTime style={{ color: missed ? techColors.danger : undefined }}>
          {formatDate(timeSource)}
        </CallTimelineTime>
      </CallTimelineBubble>
    </CallTimelineRow>
  );
};

export default CallTimelineItem;
